import { Dispatch } from 'redux'
import { useThunkActions } from '../useThunkActions'
import * as actions from './actions'

const getAccountKey = (accountId: string) =>
  `testEnvironment.variant.${accountId}`

// Single global key used by the axios interceptor so the active variant
// is readable without dispatching through Redux on every API call.
const ACTIVE_KEY = 'testEnvironment.active.variant'

function getStoredVariant(
  accountId = 'MISSING_ACCOUNT_ID'
): actions.TestEnvironmentVariant {
  const stored = localStorage.getItem(getAccountKey(accountId))
  const variant: actions.TestEnvironmentVariant =
    stored === 'test' ? 'test' : 'prod'

  localStorage.setItem(ACTIVE_KEY, variant)

  return variant
}

function saveToLocalStorage(
  variant: actions.TestEnvironmentVariant,
  accountId = 'MISSING_ACCOUNT_ID'
): void {
  localStorage.setItem(getAccountKey(accountId), variant)
  localStorage.setItem(ACTIVE_KEY, variant)
}

/**
 * Drops the global active variant. The key is not account scoped, so it must
 * not outlive the session that set it — the axios interceptor reads it on
 * every request, including those fired before the next account initializes.
 */
export function clearActiveVariant(): void {
  localStorage.removeItem(ACTIVE_KEY)
}

export function initializeTestEnvironment(accountId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.initialize({ variant: getStoredVariant(accountId) }))
  }
}

function updateTestEnvironment(
  accountId: string,
  variant: actions.TestEnvironmentVariant
) {
  return (dispatch: Dispatch) => {
    saveToLocalStorage(variant, accountId)
    dispatch(actions.update({ variant }))
  }
}

export const useTestEnvironmentActions = () => ({
  initializeTestEnvironment: useThunkActions(initializeTestEnvironment),
  updateTestEnvironment: useThunkActions(updateTestEnvironment)
})
